import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ae5048c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsCard: require('/opt/airport.kg/src/components/news/card.vue').default,SuluTemplateNewsList: require('/opt/airport.kg/node_modules/razlet-sulu-sdk/src/components/template/news-list.vue').default,Sulu: require('/opt/airport.kg/node_modules/razlet-sulu-sdk/src/components/index.vue').default})
